import { render } from "./management.cattle.io.feature.vue?vue&type=template&id=5ee54a6b&scoped=true"
import script from "./management.cattle.io.feature.vue?vue&type=script&lang=js"
export * from "./management.cattle.io.feature.vue?vue&type=script&lang=js"

import "./management.cattle.io.feature.vue?vue&type=style&index=0&id=5ee54a6b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ee54a6b"]])

export default __exports__